import { useTranslation } from 'react-i18next';
import SearchableSelect from '../searchableSelect/searchableSelect';
import { useTaskStatusSelect } from './useTaskStatusSelect';

interface TaskStatusSelectProps {
  onOpenPicker: () => void;
}

/**
 * Its own component so the status list is only fetched where the field is rendered. It renders the
 * trigger button directly, which the form's focus helpers rely on.
 */
const TaskStatusSelect = ({ onOpenPicker }: Readonly<TaskStatusSelectProps>) => {
  const { t } = useTranslation();
  const select = useTaskStatusSelect();

  return (
    <SearchableSelect
      {...select}
      ariaLabel={t('task:status')}
      placeholder={t('task:selectStatus')}
      searchPlaceholder={t('task:searchStatuses')}
      onSearchIconClick={onOpenPicker}
      data-field="status"
      data-testid="status-button"
    />
  );
};

export default TaskStatusSelect;
